import {NullAsDefault, renderIfElse} from "../../../Shared";
import classNames from "classnames";
import React from "react"
import useTranslate from "../../../../modules/local/useTranslate";

export const SubClassTags = ({items = [], selected, setSelected = NullAsDefault}) => {
  const t = useTranslate();

  return (
    <div className="flex flex-wrap gap-y-1 gap-x-2">
      {
        items.filter(e => !!e).map((e, i) => (
          <span
              key={i}
              style={{ padding: '2px 14px', height: 24 }}
              className={classNames(
                  "flex flex-center cursor-pointer rounded-md font-semibold text-xs",
                  selected === e ? "bg-primary-100 hover:bg-primary-200 text-primary" : "background-100 hover:background-200 text-color-300 hover:text-color-000"
              )}
              onClick={() => {
                if (selected === e) {
                  setSelected(null)
                } else {
                  setSelected(e)
                }
              }}>
            {renderIfElse(e, e, t('not yet classified'))}
          </span>
        ))
      }
    </div>
  )
}